export const SET_COLLECTION = "SET_COLLECTION";
